import React from "react";
import "./TicketTransferActionBar.scss";

// Components
import { ButtonNew as Button } from "components/buttonNew";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faGift, faPaperPlane } from "@fortawesome/pro-regular-svg-icons";

interface ITicketTransferActionBarProps {
  selectedLength?: number;
  disabled?: boolean;
  onVoid?: () => void;
  onRedeem?: () => void;
  onTransfer?: () => void;
} 
export default function TicketTransferActionBar(props: ITicketTransferActionBarProps): JSX.Element {
  return (
    <div className="ticket-transfer-action-bar">
      <div className="flex justify-start text-sm">

        <div 
          className={classNames(
            "selected-count",
            {
              "selected-count-disabled": !props.disabled,
            },
          )}
        >
          {props.selectedLength} Selected
        </div>
        
        {/* Redeem */}
        <div>
          <Button 
            size="small" 
            style={{ borderRadius: 0 }} 
            disabled={!props.disabled} 
            className="button" 
            onClick={() => props.onRedeem()}
          >
            <FontAwesomeIcon className={'mr-2'} icon={faGift} /> Redeem
          </Button>
        </div>

        {/* Void */}
        <div>
          <Button
            size="small" 
            style={{ borderRadius: 0 }} 
            disabled={!props.disabled} 
            className="button" 
            onClick={() => props.onVoid()}
          >
            <FontAwesomeIcon className={'mr-2'} icon={faBan}/>  Void
          </Button>
          
        </div>
        {/* Transfer */}
        <div>
          <Button 
            size="small" 
            style={{ borderTopRightRadius: 10, borderBottomRightRadius: 10, borderBottomLeftRadius: 0, borderTopLeftRadius: 0}} 
            disabled={!props.disabled} 
            className="button" 
            onClick={() => props.onTransfer()}
          >
            <FontAwesomeIcon className={'mr-2'}icon={faPaperPlane}/>  Transfer
          </Button>
          
        </div>
      </div>
    </div>
  );
}